import { Slider as MantineSlider } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import styles from "./slider.module.scss";
import type { CustomSliderFactory, IProps } from "./slider.types";

const Slider = componentWrapper<CustomSliderFactory, IProps>("Slider", (props, ref) => {
    return (
        <MantineSlider
            ref={ref}
            classNames={{
                root: styles["root"],
                label: styles["label"],
                thumb: styles["thumb"],
                trackContainer: styles["track-container"],
                track: styles["track"],
                bar: styles["bar"],
                markWrapper: styles["mark-wrapper"],
                mark: styles["mark"],
                markLabel: styles["mark-label"],
            }}
            {...props}
        />
    );
});

export { Slider };
